import Tafl from './games/tafl/index';
import Pentago from './games/pentago/index';

const games = {
  tafl: Tafl,
  pentago: Pentago,
};

class GameFactory {
  constructor(gameName, opts) {
    return new games[gameName](opts);
  }
}

export default GameFactory;
